<template>
  <!-- -->
  <div class="table-text" :style="{'color': data.textColor, 'backgroundColor': data.textBackground, 'font-size': data.textSize, 'text-align': data.textAlign}">{{data.text}}</div>
</template>

<script>


export default {
  props: {
    data: {default: () => {
        return {}
      }},
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.table-text{
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 30px;
  padding: 0 30px;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  font-size: 32px;
}
</style>